module.exports = __webpack_public_path__ + "static/media/imagem-login.4cae6b05.svg";